/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseDateFieldDefaultValueType = {
    NoDefaultValue: 'DATE_FIELD_NO_DEFAULT_VALUE',
    SetDefaultValue: 'DATE_FIELD_SET_DEFAULT_VALUE',
    NowDefaultValue: 'DATE_FIELD_NOW_DEFAULT_VALUE',
    RangeFromNowDefaultValue: 'DATE_FIELD_RANGE_FROM_NOW_DEFAULT_VALUE'
} as const;
export type DatabaseDateFieldDefaultValueType = typeof DatabaseDateFieldDefaultValueType[keyof typeof DatabaseDateFieldDefaultValueType];


export function DatabaseDateFieldDefaultValueTypeFromJSON(json: any): DatabaseDateFieldDefaultValueType {
    return DatabaseDateFieldDefaultValueTypeFromJSONTyped(json, false);
}

export function DatabaseDateFieldDefaultValueTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseDateFieldDefaultValueType {
    return json as DatabaseDateFieldDefaultValueType;
}

export function DatabaseDateFieldDefaultValueTypeToJSON(value?: DatabaseDateFieldDefaultValueType | null): any {
    return value as any;
}

